var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_384)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9423 15.5C15.4474 15.5 15.875 15.325 16.225 14.975C16.575 14.625 16.75 14.1974 16.75 13.6923V2.30773C16.75 1.80259 16.575 1.37502 16.225 1.02502C15.875 0.675025 15.4474 0.500025 14.9423 0.500025H3.55771C3.0526 0.500025 2.62504 0.675025 2.27504 1.02502C1.92504 1.37502 1.75004 1.80259 1.75004 2.30773V13.6923C1.75004 14.1974 1.92504 14.625 2.27504 14.975C2.62504 15.325 3.0526 15.5 3.55771 15.5H14.9423ZM17.6923 18.1922C18.1974 18.1922 18.625 18.0172 18.975 17.6672C19.325 17.3172 19.5 16.8896 19.5 16.3845V4.24997C19.5 4.03716 19.4282 3.85896 19.2846 3.71537C19.141 3.57179 18.9628 3.5 18.75 3.5C18.5372 3.5 18.359 3.57179 18.2154 3.71537C18.0718 3.85896 18 4.03716 18 4.24997V16.3845C18 16.4615 17.968 16.532 17.9039 16.5961C17.8398 16.6602 17.7692 16.6923 17.6923 16.6923H5.55778C5.34496 16.6923 5.16675 16.764 5.02315 16.9076C4.87957 17.0512 4.80778 17.2294 4.80778 17.4422C4.80778 17.655 4.87957 17.8332 5.02315 17.9768C5.16675 18.1204 5.34496 18.1922 5.55778 18.1922H17.6923Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_384",
    x: 0.750038,
    y: 0.500025,
    width: 19.75,
    height: 19.6922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.a2de2795e3db22346a295982225a0cf4.svg";
export { ForwardRef as ReactComponent };